import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  C3MiniBoard,
  D1MiniBoard,
  ESP32MiniBoard,
} from '../components/BinaryOverview';
import { StoreContext } from '../lib/Store';
import { boards } from '../utils/constants';

const Home = ({ title, subTitle, group }) => {
  const { state } = useContext(StoreContext);
  const [binaries, setBinaries] = useState([]);
  const [cardTitle, setCardTitle] = useState('C3-Mini');

  useEffect(() => {
    const result = state.data?.binaries || [];
    if (result.length > 0) {
      setBinaries(result);
    }
  }, [state]);

  return (
    <>
      <div className='pagetitle'>
        <h1>{title}</h1>
        <nav>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item'>
              <Link to={'#!'}>Home</Link>
            </li>
            <li className='breadcrumb-item active'>{subTitle}</li>
          </ol>
        </nav>
      </div>
      {/* <!-- End Page Title --> */}

      <section className='section dashboard'>
        <div className='row'>
          {/* <!-- Left side columns --> */}
          <div className='col-lg-12'>
            <div className='row'>
              {/* Binary Item */}
              <div className='col-xxl-12 col-xl-12'>
                <div className='card'>
                  <div className='card-body pb-0'>
                    <h5 className='card-title'>
                      {cardTitle} <span>| {title}</span>
                    </h5>
                    <ul
                      className='nav nav-tabs nav-tabs-bordered d-flex'
                      id='borderedTabJustified'
                      role='tablist'
                    >
                      <li className='nav-item flex-fill' role='presentation'>
                        <button
                          className='nav-link w-100 active'
                          id='c3-mini-tab'
                          data-bs-toggle='tab'
                          data-bs-target='#bordered-justified-c3-mini'
                          type='button'
                          role='tab'
                          aria-controls='c3-mini'
                          aria-selected='true'
                          onClick={() => setCardTitle('C3-Mini')}
                        >
                          {boards.C3_MINI}
                        </button>
                      </li>
                      <li className='nav-item flex-fill' role='presentation'>
                        <button
                          className='nav-link w-100'
                          id='d1-mini-tab'
                          data-bs-toggle='tab'
                          data-bs-target='#bordered-justified-d1-mini'
                          type='button'
                          role='tab'
                          aria-controls='d1-mini'
                          aria-selected='false'
                          tabIndex='-1'
                          onClick={() => setCardTitle('D1-Mini')}
                        >
                          {boards.D1_MINI}
                        </button>
                      </li>
                      <li className='nav-item flex-fill' role='presentation'>
                        <button
                          className='nav-link w-100'
                          id='esp32-tab'
                          data-bs-toggle='tab'
                          data-bs-target='#bordered-justified-esp32'
                          type='button'
                          role='tab'
                          aria-controls='esp32'
                          aria-selected='false'
                          tabIndex='-1'
                          onClick={() => setCardTitle('ESP32')}
                        >
                          {boards.ESP32_MINI}
                        </button>
                      </li>
                    </ul>
                    <div
                      className='tab-content pt-2'
                      id='borderedTabJustifiedContent'
                    >
                      {/* C3-Mini Binaries */}
                      <div
                        className='tab-pane fade active show'
                        id='bordered-justified-c3-mini'
                        role='tabpanel'
                        aria-labelledby='c3-mini-tab'
                      >
                        <div className='news'>
                          {binaries.map((binary, i) => (
                            <>
                              <C3MiniBoard
                                binary={binary}
                                group={group}
                                key={`${boards.C3_MINI}-${binary.id}`}
                              />
                            </>
                          ))}
                        </div>
                      </div>
                      {/* D1-Mini Binaries */}
                      <div
                        className='tab-pane fade'
                        id='bordered-justified-d1-mini'
                        role='tabpanel'
                        aria-labelledby='d1-mini-tab'
                      >
                        <div className='news'>
                          {binaries?.map((binary, i) => (
                            <D1MiniBoard
                              binary={binary}
                              group={group}
                              key={`${boards.D1_MINI}-${binary.id}`}
                            />
                          ))}
                        </div>
                      </div>
                      {/* ESP32 Binaries */}
                      <div
                        className='tab-pane fade'
                        id='bordered-justified-esp32'
                        role='tabpanel'
                        aria-labelledby='esp32-tab'
                      >
                        <div className='news'>
                          {binaries?.map((binary, i) => (
                            <ESP32MiniBoard
                              binary={binary}
                              group={group}
                              key={`${boards.ESP32_MINI}-${binary.id}`}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* End Binary Item */}
            </div>
          </div>
          {/* <!-- End Left side columns --> */}
        </div>
      </section>
    </>
  );
};

export default Home;
